// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import Boot from '@/Boot'
import Moment from 'moment'
// import VueResource from 'vue-resource'
import axios from 'axios'
import {store} from './store'
import VueAxios from 'vue-axios'
import VueProgressBar from 'vue-progressbar'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCookie from 'vue-cookie'
import VueLocalStorage from 'vue-localstorage'
// import VueSessionStorage from 'vue-sessionstorage'

import Send from './mixins/Send'
import Notify from './mixins/Notify'

Vue.config.productionTip = false
Vue.prototype.$moment = Moment
Vue.prototype.$Send = Send
Vue.prototype.$Notify = Notify
Vue.prototype.$CONFIG = require('./config')

Vue.use(Vuetify)
// Vue.use(VueResource)
Vue.use(VueAxios, axios)
Vue.use(VueCookie)
Vue.use(VueLocalStorage)
// Vue.use(VueSessionStorage)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})
Vue.use(VueSweetalert2)

Moment.locale('id')

axios.defaults.withCredentials = true

/* eslint-disable no-new */
new Vue({
  el: '#boot',
  store,
  render: h => h(Boot)
})



// WEBPACK FOOTER //
// ./src_suopass/main.js